import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class UniversityEmiLoanDetailService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    createByAdmin(id, data): Observable<any> {
        return this.postRequestWithoutDataDeletion(AppUrl.UNIVERSITY_EMI_LOAN_DETAIL(id), data);
    }

    detailByAdmin(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITY_EMI_LOAN_DETAIL(id));
    }

    updateByAdmin(id, data): Observable<any> {
        return this.putRequestWithoutDataDeletion(AppUrl.UNIVERSITY_EMI_LOAN_DETAIL(id), data);
    }
}
